<template>
  <div>
    <homelogo />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <v-row>
      <v-col cols="12" lg="6" md="6" sm="12">
        <h1 class="titles3 text-center">Contáctanos</h1>
        <div class="bckForm text-center">
          <form @submit.prevent="sendEmail">
            <v-text-field
              label="Nombre"
              name="user_name"
              filled
              outlined
              rounded
              solo
              v-model="nombreContacto"
              color="orange"
              class="borderorange"
              hide-details
            ></v-text-field>
            <br>
            <v-text-field
              label="Correo Electronico"
              name="correo"
              filled
              outlined
              rounded
              solo
              v-model="correoContacto"
              color="orange"
              class="borderorange"
              hide-details
            ></v-text-field>
            <br>
            <v-text-field
              label="Teléfono / Celular"
              name="tel"
              filled
              outlined
              rounded
              solo
              v-model="telefonoContacto"
              color="orange"
              class="borderorange"
              hide-details
            ></v-text-field>
            <br>
            <v-textarea
              label="¿Cómo podemos ayudarte?"
              name="observations"
              filled
              outlined
              rounded
              solo
              v-model="comentariosContacto"
              color="orange"
              class="borderorange"
              height="250"
              hide-details
            ></v-textarea>
            <br>
            <v-btn
              width="90%"
              height="55"
              rounded
              color="blue"
              class="mx-auto white--text"
              type="submit"
            >Enviar</v-btn>
            <br>
            <tooltipbtn />
            <!-- <v-btn @click="clear">clear</v-btn> -->
          </form>
        </div>
        <!-- <v-card-text class="text-center"></v-card-text> -->
        <!-- <v-row class="back"></v-row> -->
      </v-col>
      <v-col cols="12" lg="6" md="6" sm="12" class="floatcenter">
        <v-img width="100%" src="@/assets/contactanos/imagen_lado_derecho_contacto.png"></v-img>
      </v-col>
    </v-row>
    <!-- <form class="contact-form" @submit.prevent="sendEmail">
      <label>Name</label>
      <input type="text" name="user_name" />
      <label>Email</label>
      <input type="email" name="user_email" />
      <label>Message</label>
      <textarea name="message"></textarea>
      <input type="submit" value="SendMail" />
    </form>

    <form name="order" action="/cgi-sys/cgiemail/plantilla.txt" method="post">
      <input value="http://localhost:8080/contacto.html" name="enviado" type="hidden" />
      Nombre:
      <input name="nombre" />
      Direccion:
      <input name="direccion" />
      Empresa:
      <input name="empresa" />
      Cargo:
      <input name="cargo" />
      Telefono:
      <input name="telefono" />
      Celular:
      <input name="celular" />
      Email:
      <input name="email" />
      Sitio web:
      <input name="sitioweb" />
      <input type="submit" value="Enviar" />
    </form>-->
    <v-snackbar v-model="snackbar" vertical :color="color" top>
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn color="indigo" text v-bind="attrs" @click="snackbar = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import emailjs from "emailjs-com";
import homelogo from "@/components/homelogo/homelogo.vue";
import tooltipbtn from "@/components/tooltip.vue";
export default {
  components: {
    homelogo,
    tooltipbtn
  },
  data() {
    return {
      color: "green",
      text: "",
      snackbar: false,
      nombreContacto: null,
      correoContacto: null,
      telefonoContacto: null,
      comentariosContacto: null
    };
  },
  methods: {
    recaptcha() {
      return this.$recaptcha('login').then((token) => {
        console.log(token) // Will print the token
      })
      // .catch((e)=>{
        // clave site
        // 6LesXK4ZAAAAAN8wzzIXMTTjjt0-iZhnROb90Y0A
        //clave secreta
        // 6LesXK4ZAAAAAHd0bbwiX72KFfkdXkwgJiHOfpZY
        // console.log(e)
      // })
    },
    sendEmail(e) {
      console.log(e);
      // var obj={user_name:"asdf",user_email:"mail",message:"mst"}
      this.recaptcha().then(()=>{
      emailjs
        .sendForm(
          "gmail",
          "template_gj3VK0oQ",
          e.target,
          "Ef4pW9SP33f_8T-Rv"
        )
        .then(
          result => {
            this.color = "green";
            this.text = "Su correo ha sido enviado";
            this.snackbar = true;
            (this.nombreContacto = null),
              (this.correoContacto = null),
              (this.telefonoContacto = null),
              (this.comentariosContacto = null);
            console.log("SUCCESS!", result.status, result.text);
          },
          error => {
            this.text =
              "Se ha generado un error por favor comuníquese con el administrador";
            this.color = "red";
            console.log("FAILED...", error);
            this.snackbar = true;
          }
        );
    }).catch((e)=>{
         this.text =
              "Se ha generado un error por favor comuníquese con el administrador";
            this.color = "red";
            this.snackbar = true;
            console.log("FAILED...", e);
      })
      }
  }
};
</script>
<style scoped>
.floatcenter {
  display: flex;
  display: -webkit-flex;
  margin: auto;
}
.borderorange {
  border-color: rgb(255, 144, 0);
  box-shadow: 1px 1px 1px rgb(255, 144, 0) inset, 0 0 2px rgba(255, 144, 0);
  outline: 0 none;
  outline-color: orange;
  /* width: 400px; */
}
.back {
  padding: 20%;
  background-image: url("../assets/Donaciones/fomulario_para_postularme.png");
  background-size: cover;
  /* background-size: auto; */
}
.imglogo {
  position: absolute;
  width: 20%;
  z-index: 99;
}
.bckForm {
  padding-left: 20%;
  padding-right: 20%;
  padding-top: 22%;
  padding-bottom: 20%;
  background-image: url("../assets/formularios/formulario_contacto1.png");
  background-size: 100% 100%;
}
</style>
